import { Vector2 } from "../common/vector2.js";
import { ITransformParams } from "../types/transform_params.js";
import { Easing, TransformBase, TransformType } from "./transform_base.js";
import { Transformable } from "./transformable.js";

export class TransformScale<T extends Transformable> extends TransformBase
{
  private readonly target: T;
  private from: Vector2;
  private dest: Vector2;

  constructor(
    target: T,
    
    is_important: boolean,
    from: Vector2|null, // may be null for 'important'
    dest: Vector2,
    
    anim_start_time: number,
    duration_in_ms: number,

    optional_params: ITransformParams = {}
  )
  {
    super( 
      TransformType.Scaling,
      anim_start_time,
      duration_in_ms,
      is_important,
      optional_params
    );

    this.target = target;
    this.from   = from ?? new Vector2( 1, 1 );
    this.dest   = dest.clone();
  }

  protected getTarget():any { return this.target; }

  protected initImportant():void
  {
    this.from = this.target.getScaleImportant().clone();
  }

  protected onUpdateTransform( eased: number ): void
  {
    const scale = Vector2.lerp( this.from, this.dest, eased );
    //console.log( `TransformScale.onUpdateTransform( eased ${eased}, is_finished ${is_finished} )   scale ${this.scale}   from ${this.from}   to ${this.to}` );

    if ( this.isImportant() )
      this.target.setScale( scale );
    else
      this.target.addToScale( scale );
  }

  //public startValue():Vector2 { return this.from; };
  //public destValue ():Vector2 { return this.to; }

  //public setStart      ( value:Vector2 ):void { this.from = value; }
  //public setDestination( value:Vector2 ):void { this.to = value; }

  public toStrTransform():string { return `TransformScale   from ${this.from}  to ${this.dest}`; }
}
